import React from 'react';
import '../events_page/penaung_diraja.css';

const PenaungDiraja = () => {
  return (
    <article className = "articleContainer">
      {/* Top Square Image */}
      <div className="articleImageWrapper">
        <img 
          src="https://ik.imagekit.io/axiomhives/parm_assets/event/WhatsApp%20Image%202026-06-09%20at%2011.10.58%20PM.jpeg" 
          alt="Yang Mulia Datin Paduka Seri Afzaa Fadini" 
          className="topImage"
        />
      </div>

      {/* Article Content */}
      <div className= "contentWrapper">
        <h1 className= "Articletitle">
          Yang Mulia Datin Paduka Seri Afzaa Fadini Dilantik Sebagai Penaung Diraja Persatuan Arborist Malaysia (PArM)
        </h1>
        
        <div className= "ArticleDate">9 Jun 2026</div>
        
        <hr className= "ArticleDivider" />

        <div className="bodyText">
          <p className="leadParagraph">
            Persatuan Arborist Malaysia (PArM) dengan penuh sukacita dan penghargaan merakamkan ucapan terima kasih 
            atas perkenan Yang Mulia Datin Paduka Seri Afzaa Fadini binti Dato’ Abdul Aziz menerima pelantikan sebagai 
            Penaung Diraja Persatuan Arborist Malaysia (PArM), berkuat kuasa mulai 20 April 2026.
          </p>

          <p>
            Pelantikan ini merupakan satu penghormatan besar kepada PArM dan amat bermakna memandangkan 
            Yang Mulia Datin Paduka Seri mempunyai minat, pengalaman dan komitmen yang mendalam dalam bidang 
            arborikultur, pemuliharaan alam sekitar dan pembangunan mampan.
          </p>

          <p>
            Yang Mulia Datin Paduka Seri merupakan seorang arborist bertauliah yang telah mengikuti dan berjaya 
            menamatkan Program Pensijilan Arborist (Arborist Certification Program) Siri Ke-24 anjuran PArM, 
            serta memiliki Ijazah Sarjana (Master of Arts) dalam Sustainable Cities daripada King's College London.
          </p>

          <p>
            Penglibatan aktif Yang Mulia Datin Paduka Seri dalam pelbagai inisiatif berkaitan kelestarian 
            mencerminkan komitmen berterusan terhadap pembangunan bandar lestari, pemeliharaan alam sekitar dan 
            kesejahteraan komuniti. Pengalaman, kepakaran dan aspirasi Yang Mulia Datin Paduka Seri amat selari 
            dengan objektif PArM untuk memperkasa profesion arborist dan mempromosikan amalan pengurusan pokok yang 
            mampan di Malaysia.
          </p>

          <p>
          {/* <blockquote className="ArticleQuote"> */}
            PArM turut menjunjung tinggi aspirasi Yang Mulia Datin Paduka Seri yang menzahirkan harapan agar peranan 
            ini dapat menyokong usaha persatuan dalam memperkukuhkan bidang arborikultur serta memupuk kesedaran 
            masyarakat terhadap kepentingan penjagaan pokok dan kelestarian alam sekitar.
          {/* </blockquote> */}
          </p>
          
          <p>
            Semoga dengan perkenan dan naungan Diraja ini, Persatuan Arborist Malaysia akan terus berkembang sebagai 
            peneraju profesional arborikultur tropika serta menjadi pemangkin kepada usaha pemeliharaan pokok dan 
            landskap hijau negara demi manfaat generasi masa hadapan.
          </p>
        </div>
      </div>
    </article>
  );
};

export default PenaungDiraja;